export default {"src":"/_next/static/media/successTickIcon.706be0f1.svg","height":45,"width":71,"blurWidth":0,"blurHeight":0};